import { Dropdown, Form, Menu } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDownIcon } from "../../../../../../resource/icons";
import { createNoticeSetting } from "../../../../store/actions/actions";

const NoticeText = ({ fieldKey, templates }) => {
	const dispatch = useDispatch();
	const [chevronOpened, setChevronOpened] = useState(false);
	const currentTemplateId = useSelector(
		(store) => store.debtsStore.createNotice[fieldKey]
	);
	const template = templates?.find((t) => t.id === currentTemplateId);

	const menu = (
		<Menu>
			{templates?.map((template) => (
				<Menu.Item
					key={template.id}
					onClick={() => {
						setChevronOpened(!chevronOpened);
						dispatch(createNoticeSetting({ [fieldKey]: template?.id }));
					}}
				>
					{template ? `Шаблон №${template.id}` : "Выберите шаблон"}
				</Menu.Item>
			))}
		</Menu>
	);
	return (
		<div className="notice_text_container">
			<Form.Item label={"Оповещение"} colon={false}>
				<div
					className={`template_text ${
						template?.id ? "" : "template_text-placeholder"
					}`}
				>
					{template?.text || "Шаблон оповещения"}
				</div>
			</Form.Item>

			<Dropdown
				defaultValue={currentTemplateId || templates?.[0].id}
				overlay={menu}
				onVisibleChange={() => setChevronOpened(!chevronOpened)}
			>
				<div className="dropdown_notice_text">
					<span>
						{template ? `Шаблон №${template?.id}` : "Выберите шаблон"}
					</span>
					<ChevronDownIcon
						className={chevronOpened ? "chevron chevron_opened" : "chevron"}
					/>
				</div>
			</Dropdown>
		</div>
	);
};

export default NoticeText;
